import axiosClient from './axiosClient';

export const getLessons = (params?: Record<string, any>) => {
    return axiosClient.get('/lessons', { params });
};

export const getPublicLessons = (limit: number = 10) => {
    return axiosClient.get('/lessons/public', { params: { limit } });
};

export const createLesson = (data: Record<string, any>) => {
    return axiosClient.post('/lessons', data);
};

export const updateLesson = (id: string | number, data: Record<string, any>) => {
    return axiosClient.put(`/lessons/${id}`, data);
};

export const getLessonDetail = (id: string | number) => {
    return axiosClient.get(`/lessons/${id}`);
};

export const deleteLesson = (id: string | number) => {
    return axiosClient.delete(`/lessons/${id}`);
};

// --- Lesson Access ---

export const getLessonAccess = (id: string | number) => {
    return axiosClient.get(`/lessons/${id}/access`);
};

export const grantLessonAccess = (id: string | number, data: { student_id?: string, class_id?: string }) => {
    return axiosClient.post(`/lessons/${id}/access`, data);
};

export const revokeLessonAccess = (accessId: string) => {
    return axiosClient.delete(`/lessons/access/${accessId}`);
};

export const updateLessonAccessStatus = (accessId: string, status: string) => {
    return axiosClient.patch(`/lessons/access/${accessId}/status`, { status });
};

export const lessonApi = {
    importLessons: (file: File, isMasterData: boolean = false) => {
        const formData = new FormData();
        formData.append('file', file);
        if (isMasterData) {
            formData.append('is_master_data', 'true');
        }
        return axiosClient.post('/lessons/import', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }).then(res => res.data);
    }
};

// --- Book 3D Access ---
export const getBook3DAccess = (id: string | number) => {
    return axiosClient.get(`/lessons/${id}/book3d-access`);
};

export const grantBook3DAccess = (id: string | number, data: { student_id?: string, class_id?: string }) => {
    return axiosClient.post(`/lessons/${id}/book3d-access`, data);
};

export const revokeBook3DAccess = (accessId: string) => {
    return axiosClient.delete(`/lessons/book3d-access/${accessId}`);
};
